import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import Header from "../../Header/Header";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import toast, { Toaster } from "react-hot-toast";
import { Row, Col, Button, Nav, Tab, Pagination } from "react-bootstrap";
import { Context } from "../../../utils/context";
import "react-datepicker/dist/react-datepicker.css";
import PendingOrdersTable from "./PendingOrdersTable/PendingOrdersTable";
import UnshippedTable from "./UnshippedTable/UnshippedTable";
import CancelledTable from "./CancelledTable/CancelledTable";
import RejectedTable from "./RejctedTable/RejecterTable";
import SentTable from "./SentTable/SentTable";
import ReturnTable from "./ReturnTable/ReturnTable";
import RefundTable from "./RefundTable/RefundTable";
import {
  IDS,
  OrderStatusIds,
  ReplaceStatusIds,
  ReturnStatusIds,
} from "../../../utils/common";
import ReplaceTable from "./ReplaceTable/ReplaceTable";
import PackingTable from "./Packing/Packing";
import AcceptedOrdersTable from "./AcceptedOrdersTable/AcceptedOrdersTable";
import QualityCheckTable from "./QualityCheck/QualityCheck";
import PickUpTable from "./PickUpTable/PickUpTable";
import DeliveredTable from "./DeliveredTable/DeliveredTable";
import StoppedTable from "./StoppedTable/StoppedTable";
import DiscardedTable from "./DiscardedTable/DiscardedTable";
library.add(fas);

// ********************************************************************************************************************************************************

const Tables = () => {
  const { getData, Select2Data } = useContext(Context);

  const OrderByOptions = [
    { value: "ASC", label: "Sort-by date (Ascending)" },
    { value: "DESC", label: "Sort-by date (Descending)" },
  ];

  const resultsPerPageOptions = [
    { value: 25, label: "Results per page: 25" },
    { value: 50, label: "Results per page: 50" },
    { value: 100, label: "Results per page: 100" },
  ];

  const [statusCount, setStatusCount] = useState({});
  const [storeCategories, setStoreCategories] = useState([]);
  const [productCategories, setProductCategories] = useState([]);
  const [vendorServices, setVendorServices] = useState([]);

  const GetAllCounts = async () => {
    const response = await getData("/common/masters/all-count-order-status");
    setStatusCount(response?.data);
  };

  const getAllSCategories = async () => {
    const response = await getData("/common/masters/all-s-category");
    if (response?.success) {
      setStoreCategories(
        await Select2Data(response?.data?.allCategories, "s_category_id"),
      );
    }
  };

  const [user, setUser] = useState({});
  const GetUser = async () => {
    const response = await getData(`/common/auth/usersingleget`);
    if (response?.success) {
      setUser(response?.data);
    }
    if (response?.data?.Store_Detail) {
      const productCategory = await getData(
        `/common/masters/all-store-product-categories/${response?.data?.Store_Detail?.id}`,
      );
      if (productCategory?.success) {
        setProductCategories(
          await Select2Data(productCategory?.data, "p_category_id"),
        );
      }
      const vendorServices = await getData(
        `/common/masters/all-vendors-services/${response?.data?.Store_Detail?.id}`,
      );
      if (vendorServices?.success) {
        setVendorServices(
          await Select2Data(vendorServices?.data, "service_id"),
        );
      }
    }
  };
  useEffect(() => {
    GetUser();
  }, []);

  useEffect(() => {
    GetAllCounts();
    // getAllSCategories();
  }, []);

  const [payment_status, setPayment_status] = useState(null);
  const [return_status_id, setReturnStatus] = useState(1);
  const [searchOrderStatus, setSearchOrderSatatus] = useState(
    OrderStatusIds.PickupSchedued,
  );
  const [replace_order_status_id, setReplaceStatusId] = useState("");

  const [activeTab, setActiveTab] = useState("Pending");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Orders"} link={"/employee/employee_details"} />
        <section className="AdvanceDashboard">
          <div className="col-xxl-12 col-xl-12 p-0 ">
            <div className="row MainRowsec me-0 ms-0 p-2">
              <section className="Tabels tab-radio tab-radio mt-3">
                <div className="">
                  <div className="order-tab-holder">
                    <Tab.Container
                      id="left-tabs-example"
                      defaultActiveKey="Pending"
                    >
                      <Row className="p-2">
                        <Col sm={12}>
                          <Nav
                            variant="pills"
                            className="mb-3"
                            onSelect={(k) => setActiveTab(k)}
                          >
                            <Nav.Item>
                              <Nav.Link eventKey="Pending">
                                <span>{statusCount?.Pending}</span> Pending
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="Accepted">
                                <span>{statusCount?.Processing}</span> Accepted
                                Order
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                              <Nav.Link eventKey="Unshipped">
                                <span>{statusCount?.Preparing}</span>
                                Preparing Order
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                              <Nav.Link eventKey="QualityCheck">
                                <span>
                                  {statusCount?.OrderUnderQualityCheck}
                                </span>{" "}
                                Order Under Quality Check
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="Pickup">
                                <span>{statusCount?.PickupScheduled}</span>{" "}
                                Pickup
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="Delivered">
                                <span>{statusCount?.Delivered}</span> Delivered
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                              <Nav.Link eventKey="Rejected">
                                <span>{statusCount?.Rejected}</span> Rejected
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="Stopped">
                                <span>{statusCount?.Stopped}</span> Cancelled
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="Discarded">
                                <span>{statusCount?.Discarded}</span> Discarded
                              </Nav.Link>
                            </Nav.Item>

                            {/* <Nav.Item
                              onClick={() => {
                                setSearchOrderSatatus(
                                  OrderStatusIds.PickupSchedued
                                );
                                handleTabClick("waitingForPickup");
                              }}
                            >
                              <Nav.Link eventKey="Sent">
                                <span>
                                  {statusCount?.OrderUnderQualityCheck +
                                    statusCount?.PickupScheduled +
                                    statusCount?.Delivered}
                                </span>
                                Sent
                              </Nav.Link>
                            </Nav.Item> */}
                            {/* <Nav.Item
                              onClick={() => {
                                setReturnStatus(
                                  ReturnStatusIds.ReturnRequested
                                );
                                handleTabClick("ReturnRequested");
                              }}
                            >
                              <Nav.Link eventKey="Returns">
                                <span>
                                  {statusCount?.ReturnRequested +
                                    statusCount?.ReturnPickupScheduled +
                                    statusCount?.ReturnItemPicked +
                                    statusCount?.ReturnRejected +
                                    statusCount?.Returned}
                                </span>
                                Return
                              </Nav.Link>
                            </Nav.Item> */}
                            {/*<Nav.Item
                              onClick={() => {
                                setPayment_status("");
                                handleTabClick("RefundRequest");
                              }}
                            >
                              <Nav.Link eventKey="Refund">
                                <span>
                                  {statusCount?.RefundRequest +
                                    statusCount?.RefundAccepted +
                                    statusCount?.RefundRejected}
                                </span>
                                Refund
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item
                              onClick={() => {
                                setReplaceStatusId(
                                  ReplaceStatusIds.ReplaceRequested
                                );
                                handleTabClick("ReplaceRequest");
                              }}
                            >
                              <Nav.Link eventKey="replace">
                                <span>
                                  {statusCount?.ReplaceRequested +
                                    statusCount?.StoreItmePickupScheduled +
                                    statusCount?.StoreItemPicked +
                                    statusCount?.CustomerItemReplaced +
                                    statusCount?.StoreReplaceItemDelivered +
                                    statusCount?.ReplaceItemRejected}
                                </span>
                                Replace
                              </Nav.Link>
                            </Nav.Item> */}
                          </Nav>
                        </Col>

                        <Col sm={12}>
                          <Tab.Content>
                            {activeTab === "Pending" && (
                              <Tab.Pane eventKey="Pending">
                                <PendingOrdersTable
                                  OrderByOptions={OrderByOptions}
                                  resultsPerPageOptions={resultsPerPageOptions}
                                  productCategories={productCategories}
                                  vendorServices={vendorServices}
                                  statusCount={statusCount}
                                  user={user}
                                  GetAllCounts={() => GetAllCounts()}
                                  activeTab={activeTab}
                                />
                              </Tab.Pane>
                            )}

                            {activeTab === "Accepted" && (
                              <Tab.Pane eventKey="Accepted">
                                <AcceptedOrdersTable
                                  OrderByOptions={OrderByOptions}
                                  resultsPerPageOptions={resultsPerPageOptions}
                                  productCategories={productCategories}
                                  vendorServices={vendorServices}
                                  statusCount={statusCount}
                                  user={user}
                                  GetAllCounts={() => GetAllCounts()}
                                  activeTab={activeTab}
                                />
                              </Tab.Pane>
                            )}

                            {activeTab === "Unshipped" && (
                              <Tab.Pane eventKey="Unshipped">
                                <UnshippedTable
                                  user={user}
                                  activeTab={activeTab}
                                  statusCount={statusCount}
                                  OrderByOptions={OrderByOptions}
                                  resultsPerPageOptions={resultsPerPageOptions}
                                  storeCategories={storeCategories}
                                  productCategories={productCategories}
                                  vendorServices={vendorServices}
                                  GetAllCounts={() => GetAllCounts()}
                                />
                              </Tab.Pane>
                            )}
                            {activeTab === "QualityCheck" && (
                              <Tab.Pane eventKey="QualityCheck">
                                <QualityCheckTable
                                  user={user}
                                  OrderByOptions={OrderByOptions}
                                  resultsPerPageOptions={resultsPerPageOptions}
                                  storeCategories={storeCategories}
                                  productCategories={productCategories}
                                  vendorServices={vendorServices}
                                  statusCount={statusCount}
                                  activeTab={activeTab}
                                  handleTabClick={handleTabClick}
                                  searchOrderStatus={searchOrderStatus}
                                  setSearchOrderSatatus={setSearchOrderSatatus}
                                  GetAllCounts={() => GetAllCounts()}
                                />
                              </Tab.Pane>
                            )}
                            {activeTab === "Pickup" && (
                              <Tab.Pane eventKey="Pickup">
                                <PickUpTable
                                  user={user}
                                  OrderByOptions={OrderByOptions}
                                  resultsPerPageOptions={resultsPerPageOptions}
                                  storeCategories={storeCategories}
                                  productCategories={productCategories}
                                  vendorServices={vendorServices}
                                  statusCount={statusCount}
                                  activeTab={activeTab}
                                  handleTabClick={handleTabClick}
                                  searchOrderStatus={searchOrderStatus}
                                  setSearchOrderSatatus={setSearchOrderSatatus}
                                  GetAllCounts={() => GetAllCounts()}
                                />
                              </Tab.Pane>
                            )}

                            {activeTab === "Delivered" && (
                              <Tab.Pane eventKey="Delivered">
                                <DeliveredTable
                                  user={user}
                                  OrderByOptions={OrderByOptions}
                                  resultsPerPageOptions={resultsPerPageOptions}
                                  storeCategories={storeCategories}
                                  productCategories={productCategories}
                                  vendorServices={vendorServices}
                                  statusCount={statusCount}
                                  activeTab={activeTab}
                                  handleTabClick={handleTabClick}
                                  searchOrderStatus={searchOrderStatus}
                                  setSearchOrderSatatus={setSearchOrderSatatus}
                                  GetAllCounts={() => GetAllCounts()}
                                />
                              </Tab.Pane>
                            )}
                            {/* <Tab.Pane eventKey="Packing">
                              <PackingTable
                                user={user}
                                statusCount={statusCount}
                                OrderByOptions={OrderByOptions}
                                resultsPerPageOptions={resultsPerPageOptions}
                                storeCategories={storeCategories}
                                productCategories={productCategories}
                                vendorServices={vendorServices}
                                />
                                </Tab.Pane> */}

                            {activeTab === "Rejected" && (
                              <Tab.Pane eventKey="Rejected">
                                <CancelledTable
                                  user={user}
                                  activeTab={activeTab}
                                  statusCount={statusCount}
                                  OrderByOptions={OrderByOptions}
                                  resultsPerPageOptions={resultsPerPageOptions}
                                  storeCategories={storeCategories}
                                  productCategories={productCategories}
                                  vendorServices={vendorServices}
                                />
                              </Tab.Pane>
                            )}

                            {activeTab === "Stopped" && (
                              <Tab.Pane eventKey="Stopped">
                                <StoppedTable
                                  user={user}
                                  activeTab={activeTab}
                                  statusCount={statusCount}
                                  OrderByOptions={OrderByOptions}
                                  resultsPerPageOptions={resultsPerPageOptions}
                                  storeCategories={storeCategories}
                                  productCategories={productCategories}
                                  vendorServices={vendorServices}
                                />
                              </Tab.Pane>
                            )}
                            {activeTab === "Discarded" && (
                              <Tab.Pane eventKey="Discarded">
                                <DiscardedTable
                                  user={user}
                                  activeTab={activeTab}
                                  statusCount={statusCount}
                                  OrderByOptions={OrderByOptions}
                                  resultsPerPageOptions={resultsPerPageOptions}
                                  storeCategories={storeCategories}
                                  productCategories={productCategories}
                                  vendorServices={vendorServices}
                                />
                              </Tab.Pane>
                            )}

                            {/* <Tab.Pane eventKey="Rejected">
                              <RejectedTable
                                user={user}
                                statusCount={statusCount}
                                OrderByOptions={OrderByOptions}
                                resultsPerPageOptions={resultsPerPageOptions}
                                storeCategories={storeCategories}
                                productCategories={productCategories}
                                vendorServices={vendorServices}
                              />
                            </Tab.Pane> */}
                            {activeTab === "Sent" && (
                              <Tab.Pane eventKey="Sent">
                                <SentTable
                                  user={user}
                                  OrderByOptions={OrderByOptions}
                                  resultsPerPageOptions={resultsPerPageOptions}
                                  storeCategories={storeCategories}
                                  productCategories={productCategories}
                                  vendorServices={vendorServices}
                                  statusCount={statusCount}
                                  activeTab={activeTab}
                                  handleTabClick={handleTabClick}
                                  searchOrderStatus={searchOrderStatus}
                                  setSearchOrderSatatus={setSearchOrderSatatus}
                                  GetAllCounts={() => GetAllCounts()}
                                />
                              </Tab.Pane>
                            )}

                            {/* <Tab.Pane eventKey="Returns">
                              <ReturnTable
                                GetAllCounts={GetAllCounts}
                                user={user}
                                OrderByOptions={OrderByOptions}
                                resultsPerPageOptions={resultsPerPageOptions}
                                storeCategories={storeCategories}
                                productCategories={productCategories}
                                vendorServices={vendorServices}
                                statusCount={statusCount}
                                return_status_id={return_status_id}
                                setReturnStatus={setReturnStatus}
                                activeTab={activeTab}
                                handleTabClick={handleTabClick}
                              />
                            </Tab.Pane> */}

                            {/* <Tab.Pane eventKey="Refund">
                              <RefundTable
                                user={user}
                                OrderByOptions={OrderByOptions}
                                resultsPerPageOptions={resultsPerPageOptions}
                                storeCategories={storeCategories}
                                productCategories={productCategories}
                                vendorServices={vendorServices}
                                statusCount={statusCount}
                                setPayment_status={setPayment_status}
                                payment_status={payment_status}
                                activeTab={activeTab}
                                handleTabClick={handleTabClick}
                              />
                            </Tab.Pane> */}

                            {/* <Tab.Pane eventKey="replace">
                              <ReplaceTable
                                user={user}
                                OrderByOptions={OrderByOptions}
                                resultsPerPageOptions={resultsPerPageOptions}
                                storeCategories={storeCategories}
                                productCategories={productCategories}
                                vendorServices={vendorServices}
                                statusCount={statusCount}
                                replace_order_status_id={
                                  replace_order_status_id
                                }
                                setReplaceStatusId={setReplaceStatusId}
                                activeTab={activeTab}
                                handleTabClick={handleTabClick}
                              />
                            </Tab.Pane> */}
                          </Tab.Content>
                        </Col>
                      </Row>
                    </Tab.Container>
                  </div>

                  <div className=""></div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      <Toaster position="top-right" />
    </>
  );
};

export default Tables;
